import { useShowAlert } from "hooks/customAlert"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"
import { validate } from "./helper"
import ReCaptcha from "components/ReCaptcha"
import { classNames } from "utils/classNames"

const Login = ({
  actions: { showPass, setShowPass, handleSignIn, formTypeHandler },
  fields: { email, password },
}) => {
  const { t } = useTranslation()
  const { error } = useShowAlert()
  const [reCaptcha, setReCaptcha] = useState("")
  const [reCaptchaOpen, setReCaptchaOpen] = useState(false)

  const loginhandler = (e) => {
    e.preventDefault()

    if (
      validate({
        email: email?.value,
      }).errors.email.length <= 0
    ) {
      if (reCaptcha?.length) {
        handleSignIn({
          email: email?.value,
          password: password?.value,
        })
        setReCaptchaOpen(false)
      } else {
        setReCaptchaOpen(true)
      }
    } else {
      error(
        t(
          validate({
            email: email.value,
          }).errors.email || "login-error"
        )
      )
    }
  }

  return (
    <div className="flex flex-col justify-center p-10 lg:p-16 md:p-10 sm:p-10 xxl:p-24">
      <h4 className="text-xl font-medium text-center">{t("auth-login")}</h4>
      <form className="w-full mx-auto" autoComplete="off">
        <label className="block mb-4 ">
          <p className="mb-2 font-semibold leading-normal text-white">
            {t("auth-email")}
            <span className="mx-2 text-red-500">*</span>
          </p>
          <input
            {...email}
            className={classNames(
              email?.value &&
                validate({
                  email: email?.value,
                }).errors?.email.length > 0
                ? "border-red-500"
                : "border-[#B3B3B3]",
              "px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none rounded-xl border border-[#B3B3B3] outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700 "
            )}
            type="email"
            autoComplete="off"
            required={true}
          />
          {/* <p className="h-10 mx-2 text-red-500">
            {t(validate({ email: email?.value }).errors?.email)}
          </p> */}
        </label>
        <label className="relative block">
          <p className="mb-2 font-semibold leading-normal text-white">
            {t("auth-password")} <span className="mx-2 text-red-500">*</span>
          </p>
          <input
            {...password}
            className={classNames(
              !validate({
                password: password.value,
              }).errors?.password.length > 0
                ? "border-red-500"
                : "border-[#B3B3B3]",
              "px-4 py-3.5 w-full text-white font-medium placeholder-gray-400 bg-[rgba(57,57,57,.5)] outline-none border border-[#B3B3B3] rounded-xl  outline-offset-0 focus:border-[rgba(255,255,255,0.8)] focus:bg-gray-700"
            )}
            type={showPass ? "text" : "password"}
            autoComplete="off"
            required={true}
          />
          <button
            type="button"
            onClick={() => setShowPass((prev) => !prev)}
            className="absolute top-[55%] right-3 text-disabled-text-color"
          >
            {showPass ? (
              <AiOutlineEye size={24} />
            ) : (
              <AiOutlineEyeInvisible size={24} />
            )}
          </button>
        </label>

        <div className="flex flex-wrap items-start justify-end">
          <div className="w-auto py-2">
            <button
              type="button"
              onClick={() => {
                // setFormType("forgotPassword"), setStep("firstStep")
                formTypeHandler("forgotPassword", "firstStep")
              }}
              className="text-sm font-medium text-white hover:underline"
            >
              {t("forget-password")}
            </button>
          </div>
        </div>
        <div className="flex items-center flex-col pb-[30px] relative">
          <div className="text-center">
            <ReCaptcha onChange={setReCaptcha} />
          </div>
          {!reCaptcha?.length && reCaptchaOpen ? (
            <p className="absolute text-base text-red-500 bottom-1">
              {t("not-robot")}
            </p>
          ) : null}
        </div>
        <button
          onClick={loginhandler}
          disabled={!email.value && !password.value}
          className={classNames(
            !reCaptcha?.length && reCaptchaOpen
              ? "cursor-not-allowed"
              : "hover:bg-gray-700",
            "w-full py-4 pt-5 font-semibold text-white transition duration-200 ease-in-out border px-9 rounded-xl shadow-4xl disabled:cursor-not-allowed"
          )}
          type="button"
        >
          {t("auth-send-btn")}
        </button>
      </form>
    </div>
  )
}

export default Login
